import React from "react";

export default function Privacy() {
  return <div className="profile_container">Приватность</div>;
}
